/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputAdminPositionStockBalance
 */
export interface OutputAdminPositionStockBalance {
    /**
     * 
     * @type {string}
     * @memberof OutputAdminPositionStockBalance
     */
    cameraType?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminPositionStockBalance
     */
    connectionType?: string;
    /**
     * Атрибути дрона (null для боєкомплекту)
     * @type {string}
     * @memberof OutputAdminPositionStockBalance
     */
    missionType?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputAdminPositionStockBalance
     */
    opticDistanceKm?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputAdminPositionStockBalance
     */
    stockItemId?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminPositionStockBalance
     */
    stockItemName?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminPositionStockBalance
     */
    stockItemType?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputAdminPositionStockBalance
     */
    totalQuantity?: number;
    /**
     * Атрибути боєкомплекту (null для дрона)
     * @type {string}
     * @memberof OutputAdminPositionStockBalance
     */
    warheadType?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputAdminPositionStockBalance
     */
    weightKg?: number;
}

/**
 * Check if a given object implements the OutputAdminPositionStockBalance interface.
 */
export function instanceOfOutputAdminPositionStockBalance(value: object): boolean {
    return true;
}

export function OutputAdminPositionStockBalanceFromJSON(json: any): OutputAdminPositionStockBalance {
    return OutputAdminPositionStockBalanceFromJSONTyped(json, false);
}

export function OutputAdminPositionStockBalanceFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputAdminPositionStockBalance {
    if (json == null) {
        return json;
    }
    return {
        
        'cameraType': json['cameraType'] == null ? undefined : json['cameraType'],
        'connectionType': json['connectionType'] == null ? undefined : json['connectionType'],
        'missionType': json['missionType'] == null ? undefined : json['missionType'],
        'opticDistanceKm': json['opticDistanceKm'] == null ? undefined : json['opticDistanceKm'],
        'stockItemId': json['stockItemId'] == null ? undefined : json['stockItemId'],
        'stockItemName': json['stockItemName'] == null ? undefined : json['stockItemName'],
        'stockItemType': json['stockItemType'] == null ? undefined : json['stockItemType'],
        'totalQuantity': json['totalQuantity'] == null ? undefined : json['totalQuantity'],
        'warheadType': json['warheadType'] == null ? undefined : json['warheadType'],
        'weightKg': json['weightKg'] == null ? undefined : json['weightKg'],
    };
}

export function OutputAdminPositionStockBalanceToJSON(value?: OutputAdminPositionStockBalance | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'cameraType': value['cameraType'],
        'connectionType': value['connectionType'],
        'missionType': value['missionType'],
        'opticDistanceKm': value['opticDistanceKm'],
        'stockItemId': value['stockItemId'],
        'stockItemName': value['stockItemName'],
        'stockItemType': value['stockItemType'],
        'totalQuantity': value['totalQuantity'],
        'warheadType': value['warheadType'],
        'weightKg': value['weightKg'],
    };
}

